/** Начальное состояние */
export default {
  loading: false,
  data: null,
  error: null,
};
